/* ============================================================================
   assets/theme.js — 0000007 外壁リフォーム / Shopify テーマ 共通 JS

   出典: docs/migrations/0000007/design-r3/main.html 末尾の <script> (確定版 r26d)
   契約 3 差分で許可されたスライダーの最小実装のみ (ライブラリ不使用・
   自動送り 6 秒・ドット同期のみ)。モックの initSlider を、セクション ID が
   付いた複数スライダーへ自動適用できるよう data 属性方式へ一般化した。

   使い方 (後続セクション実装者向け):
     <div class="case-track" data-slider-track="cases-{{ section.id }}"> … </div>
     <div class="dots"      data-slider-dots="cases-{{ section.id }}">
       <button class="btn-dot" type="button" aria-label="1 枚目へ"></button> …
     </div>
   ドットは `.btn-dot` クラス必須 (モックの処方)。JS は defer を付けずに
   </body> 直前で読み込む (工程4 §5.2)。
   ========================================================================== */
(function () {
  function initSlider(track, dots) {
    if (!track || dots.length === 0) {
      return;
    }
    var idx = 0;
    var timer = null;
    var maxLeft = function () {
      return track.scrollWidth - track.clientWidth;
    };
    /* 検品 B3: 送り位置は scroll-snap のスナップ点 (タイルの offsetLeft) に一致させる。
       等分割 (maxLeft*n/(D-1)) だと mandatory スナップに戻されてドットだけ進む */
    var stepLeft = function (n) {
      var kids = track.children;
      if (kids.length === 0) {
        return 0;
      }
      var t = Math.round((n * (kids.length - 1)) / (dots.length - 1));
      return Math.min(kids[t].offsetLeft - kids[0].offsetLeft, maxLeft());
    };
    function paint() {
      dots.forEach(function (d, n) {
        d.classList.toggle('btn--fill', n === idx);
        d.classList.toggle('btn--line', n !== idx);
      });
    }
    function go(n) {
      idx = (n + dots.length) % dots.length;
      track.scrollTo({ left: stepLeft(idx), behavior: 'smooth' });
      paint();
    }
    function restart() {
      if (timer) {
        clearInterval(timer);
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      timer = setInterval(function () {
        /* 画面が広くスクロール余地が無いステップは飛ばして往復させる */
        var next = idx + 1;
        while (next < dots.length && Math.abs(stepLeft(next) - stepLeft(idx)) < 8) {
          next++;
        }
        go(next >= dots.length ? 0 : next);
      }, 6000);
    }
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        go(n);
        restart();
      });
    });
    track.addEventListener('scroll', function () {
      if (maxLeft() <= 0) {
        return;
      }
      var best = 0;
      for (var i = 1; i < dots.length; i++) {
        if (Math.abs(track.scrollLeft - stepLeft(i)) < Math.abs(track.scrollLeft - stepLeft(best))) {
          best = i;
        }
      }
      if (best !== idx) {
        idx = best;
        paint();
      }
    });
    paint();
    restart();
  }

  function boot() {
    var tracks = document.querySelectorAll('[data-slider-track]');
    Array.prototype.forEach.call(tracks, function (track) {
      var key = track.getAttribute('data-slider-track');
      var host = document.querySelector('[data-slider-dots="' + key + '"]');
      var dots = host ? Array.prototype.slice.call(host.querySelectorAll('.btn-dot')) : [];
      initSlider(track, dots);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* テーマエディタでセクションを再描画したときにスライダーを貼り直す */
  document.addEventListener('shopify:section:load', boot);
})();

/* 2026-09-28: 同一ページに contact フォームが複数あると、1 つ送信しただけで
   すべてのフォームが「送信完了」表示になる (Shopify の form.posted_successfully? はページ単位)。
   Shopify は送信元フォームの id を URL のフラグメントに付けて戻すので、それ以外の完了表示を取り除く。 */
(function () {
  if (location.search.indexOf('contact_posted=true') === -1) return;
  var target = location.hash ? location.hash.slice(1) : '';
  var nodes = document.querySelectorAll('[data-posted-for]');
  if (!nodes.length) return;
  Array.prototype.forEach.call(nodes, function (el) {
    if (!target || el.getAttribute('data-posted-for') !== target) {
      if (el.parentNode) el.parentNode.removeChild(el);
    }
  });
})();

/* ===== 電話ポップアップ (スマホ) =====
   767px 以下で tel: リンクをタップしたら発信前に #tel-popup を出す (snippets/tel-popup.liquid)。
   ポップアップ内の電話ボタンを押した時点で GA4 イベント tel_tap を 1 セッション 1 回だけ送り、そのまま発信する。
   キーイベント (コンバージョン) 化は GA4 管理画面側で tel_tap をマークする。 */
(function () {
  var MQ = '(max-width: 767px)';
  var SESSION_KEY = 'tel_tap_sent';

  function popup() { return document.getElementById('tel-popup'); }
  function isPhone() { return window.matchMedia && window.matchMedia(MQ).matches; }

  var lastFocus = null;
  function open() {
    var el = popup(); if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('tel-popup-open');
    var btn = el.querySelector('[data-tel-popup-call]'); if (btn) btn.focus();
  }
  function close() {
    var el = popup(); if (!el || el.hidden) return;
    el.hidden = true;
    document.documentElement.classList.remove('tel-popup-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function sendEvent() {
    var already = false;
    try { already = window.sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) {}
    if (already) return;
    try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    var params = { event_category: 'contact', event_label: 'tel_popup', page_path: location.pathname };
    if (typeof window.yahoo_report_conversion === 'function') { window.yahoo_report_conversion(); } /* Yahoo!広告 電話タップ CV (layout/theme.liquid) */
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'tel_tap', params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'tel_tap', event_category: 'contact', event_label: 'tel_popup', page_path: location.pathname });
    }
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href^="tel:"]');
    if (!a) {
      if (ev.target.closest && ev.target.closest('[data-tel-popup-close]')) { ev.preventDefault(); close(); }
      return;
    }
    if (a.hasAttribute('data-tel-popup-call')) { sendEvent(); close(); return; } /* 発信はブラウザに任せる */
    if (!isPhone() || !popup()) return;
    ev.preventDefault();
    open();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });
})();

/* ===== GA4 フォーム送信完了イベント =====
   Shopify の contact フォームは送信後に同じ URL へ ?contact_posted=true#<form id> で戻る。
   そのタイミングで、フォームの種類ごとに GA4 イベントを 1 回送る (同じ完了 URL を再読み込みしても再送しない)。
     contact_complete       お問い合わせ (/pages/contact)
     estimate_complete      無料見積 (/pages/estimate)
     top_contact_complete   トップの「簡単10秒お問い合わせ」
     top_estimate_complete  トップの料金欄「かんたん概算」
     reservation_complete   ショールーム来店予約 (/pages/reservation・リニューアル案)
     shindan_complete       無料診断ページのページ内フォーム (/pages/shindan)
   キーイベント (コンバージョン) 化は GA4 管理画面側で行う。 */
(function () {
  if (location.search.indexOf('contact_posted=true') === -1) return;
  var h = location.hash ? location.hash.slice(1) : '';
  var path = location.pathname.replace(/\/$/, '') || '/';
  var name;
  if (/^contact-form/.test(h) || path === '/pages/contact') name = 'contact_complete';
  else if (/^shindan-form/.test(h)) name = 'shindan_complete';
  else if (/^estimate-form/.test(h) || path === '/pages/estimate') name = 'estimate_complete';
  else if (/^reservation-form/.test(h) || path === '/pages/reservation') name = 'reservation_complete';
  else if (/^price-quote/.test(h)) name = 'top_estimate_complete';
  else if (/^quick-form/.test(h) || path === '/') name = 'top_contact_complete';
  else name = 'form_complete';
  var key = 'ga4_form_sent:' + name + ':' + h;
  try { if (window.sessionStorage.getItem(key) === '1') return; window.sessionStorage.setItem(key, '1'); } catch (e) {}
  var params = { event_category: 'contact', form_id: h, page_path: path };
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, event_category: 'contact', form_id: h, page_path: path });
  }
})();
